import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dialog as MUIDailog } from '@material-ui/core';
import withSizes from 'react-sizes';

import { dialogSelectors } from '@store/ducks';
import Sheet from 'deltoid/core/Blocks/Sheet';

import Esign from '@components/ServiceAgreement/Esign';
import EsignSuccess from '@components/ServiceAgreement/EsignSuccess';

const Dialog = ({
  type,
  open,
  onClose: onCloseProp,
  isMobile,
  getProps = {},
}) => {

  const getChild = type => {
    let child = '';
    switch (type) {
      case 'msa-review-esign': {
        child = <Esign />;
        break;
      }
      case 'msa-success': {
        child = <EsignSuccess {...getProps} dialogOnClose={handleClose} />;
        break;
      }
      default: {
        child = null;
      }
    }
    return child;
  }

  const handleClose = () => onCloseProp();

  const maxWidth = (type) => {
    switch (type) {
      case 'msa-success':
        return 'sm';
      default:
        return 'md';
    }
  }

  return (
    <>
      {
        getChild(type) ? (
          !isMobile ? (
            <MUIDailog
              open={open}
              onClose={handleClose}
              maxWidth={maxWidth(type)}
              fullWidth={['msa-review-esign', 'msa-success'].includes(type)}
            >
              {getChild(type)}
            </MUIDailog>
          ) : (
            <Sheet className='bg-white sheet-b-radius' open={open} bottom onOverlayClick={handleClose}>
              {getChild(type)}
            </Sheet>
          )
        ) : <></>
      }
    </>
  )
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});
const ResponsiveDialog = withSizes(mapSizesToProps)(Dialog);

const mapStateToProps = (state) => {
  return {
    open: dialogSelectors.open(state),
    type: dialogSelectors.type(state),
    getProps: dialogSelectors.getProps(state),
  };
};

export default connect(mapStateToProps)(ResponsiveDialog);
